// extracted by mini-css-extract-plugin
export default {"main":"main_main__X4IO6","logo":"main_logo__NN9Ld"};